import { Component } from '@angular/core';
import { I18nDetectorService } from '../../../../../core/services/i18n.detector.service';

@Component({
    selector: 'app-features',
    templateUrl: './features.component.html',
    styleUrls: ['./features.component.scss'],
    standalone: false
})
export class FeaturesComponent {
    constructor(public i18nService: I18nDetectorService) { }
}
